export enum APIStatus {
    isLoading,
    Completed,
    Error,
}
